import type { ReactNode } from 'react'

export type AssetKind = 'photo' | 'diagram' | 'video' | 'audio'

export type AssetPlaceholderProps = {
  kind: AssetKind
  subject: string
  source?: string
  promptTemplate?: string
  notes?: string
  width?: 'full' | 'half'
  children?: ReactNode
}

const KIND_LABEL: Record<AssetKind, string> = {
  photo: 'PHOTO NEEDED',
  diagram: 'DIAGRAM NEEDED',
  video: 'VIDEO NEEDED',
  audio: 'AUDIO NEEDED',
}

export default function AssetPlaceholder({
  kind,
  subject,
  source,
  promptTemplate,
  notes,
  width = 'full',
  children,
}: AssetPlaceholderProps) {
  return (
    <figure
      className={`asset-placeholder asset-placeholder--${kind} asset-placeholder--${width}`}
      data-asset-kind={kind}
      data-asset-subject={subject}
    >
      <div className="asset-placeholder__header">
        <span className="asset-placeholder__badge">{KIND_LABEL[kind]}</span>
      </div>
      <div className="asset-placeholder__body">
        <p className="asset-placeholder__subject">{subject}</p>
        {source ? (
          <p className="asset-placeholder__meta">
            <span className="asset-placeholder__meta-label">Source</span> {source}
          </p>
        ) : null}
        {promptTemplate ? (
          <p className="asset-placeholder__meta">
            <span className="asset-placeholder__meta-label">Prompt template</span>{' '}
            <code>{promptTemplate}</code>
          </p>
        ) : null}
        {notes ? <p className="asset-placeholder__notes">{notes}</p> : null}
        {children ? <div className="asset-placeholder__extra">{children}</div> : null}
      </div>
    </figure>
  )
}
